// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__3jlDX","sk-scaleout":"spinner_sk-scaleout__1DveE"};